import {
  takeOfferDynamic as _takeOfferDynamic,
  takeOfferFixed as _takeOfferFixed,
} from 'src/thirdweb/dotc'
import useDotcContract from '../useDotcContract'
import { TakeOfferDynamicParams, TakeOfferFixedParams } from './types'
import { getDenormalizedAmount } from 'src/common/apollo/utils/tokens'
import { ZERO } from 'src/common/utils/big-utils'

const useTakeOffer = () => {
  const dotcContract = useDotcContract()

  const takeOfferFixed = ({
    offerId,
    withdrawalAmountPaid,
    decimals,
    affiliate,
  }: TakeOfferFixedParams) => {
    if (!dotcContract) return

    const takeOfferTx = _takeOfferFixed({
      contract: dotcContract,
      offerId: BigInt(offerId),
      withdrawalAmountPaid: BigInt(
        getDenormalizedAmount(withdrawalAmountPaid, decimals)
      ),
      affiliate,
    })

    return takeOfferTx
  }

  const takeOfferDynamic = ({
    offerId,
    maximumDepositToWithdrawalRate = 0n,
    withdrawalAmountPaid = ZERO,
    decimals,
    affiliate,
  }: TakeOfferDynamicParams) => {
    if (!dotcContract) return

    const takeOfferTx = _takeOfferDynamic({
      contract: dotcContract,
      offerId: BigInt(offerId),
      withdrawalAmountPaid: BigInt(
        getDenormalizedAmount(withdrawalAmountPaid, decimals)
      ),
      maximumDepositToWithdrawalRate,
      affiliate,
    })

    return takeOfferTx
  }

  return {
    takeOfferFixed,
    takeOfferDynamic,
  }
}

export default useTakeOffer
